import React from "react";

const PageNotFound = () => {
    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="text-center">
                <h1>404! Page Not Found</h1>
            </div>
        </div>
    );
}

export default PageNotFound;